import PageWrapper from "@/components/layout/page-wrapper";
import LayoutTabHeader from "@/components/account-settings/layout-tab-header/layout-tab-header";
import { Outlet, useLocation } from "react-router";

const getTitle = (pathname: string) => {
    return pathname
        .split("?")[0]
        .split("/")
        .pop()
        ?.replace(/-/g, " ")
        .replace(/\b\w/g, function (l) {
            return l.toUpperCase();
        });
};

const AccountLayout = () => {
    const location = useLocation();
    return (
        <PageWrapper
            pageTitle={getTitle(location.pathname) || "Account Settings"}
            currentPage={getTitle(location.pathname)}
            previousPages={[{ title: "Account Settings", url: "/app/account-settings" }]}
        >
            <>
                <LayoutTabHeader />
            </>
            <Outlet />
        </PageWrapper>
    );
};

export default AccountLayout;
